import React, { useState, useEffect } from 'react';
import { formatearFechaLocal } from '../utils/dateUtils';
import {
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  TableSortLabel,
  Box,
  InputAdornment,
  Chip,
  Avatar,
  Card,
  CardContent,
  Grid,
  useTheme,
  useMediaQuery,
  Skeleton,
  Alert,
  Tooltip,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Badge,
  Fab
} from '@mui/material';
import {
  Search as SearchIcon,
  Payment as PaymentIcon,
  AccountBalance as AccountBalanceIcon,
  TrendingUp as TrendingUpIcon,
  Schedule as ScheduleIcon,
  GetApp as DownloadIcon,
  FilterList as FilterIcon,
  Clear as ClearIcon,
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  AttachMoney as MoneyIcon,
  DateRange as DateRangeIcon,
  People as PeopleIcon,
  Assessment as AssessmentIcon,
  Receipt as ReceiptIcon,
  Close as CloseIcon,
  Info as InfoIcon,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
  Refresh as RefreshIcon
} from '@mui/icons-material';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useEmpresa } from '../context/EmpresaContext';
import config from '../config';
import * as XLSX from 'xlsx';

function PagosAdmin() {
  const [pagos, setPagos] = useState([]);
  const [filteredPagos, setFilteredPagos] = useState([]);
  const [estadisticas, setEstadisticas] = useState({
    total_pagos: 0,
    pagos_pendientes: 0,
    pagos_proceso: 0,
    pagos_completados: 0,
    monto_total: 0,
    monto_pendiente: 0
  });
  const [trabajadores, setTrabajadores] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(20);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [exporting, setExporting] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  
  // Estados para diálogos
  const [detailDialogOpen, setDetailDialogOpen] = useState(false);
  const [selectedPago, setSelectedPago] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  
  // Estados para filtros
  const [filtros, setFiltros] = useState({
    searchTerm: '',
    estado: '',
    metodo_pago: '',
    trabajador_id: '',
    fecha_desde: '',
    fecha_hasta: ''
  });
  
  const [orderBy, setOrderBy] = useState('fecha_generacion');
  const [order, setOrder] = useState('desc');
  
  const { user } = useAuth();
  const { simboloMoneda } = useEmpresa();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    applyFilters();
   
  }, [pagos, filtros, order, orderBy]);

  const fetchData = async () => {
    await Promise.all([
      fetchPagos(),
      fetchEstadisticas(),
      fetchTrabajadores()
    ]);
  };

  // ✅ CORREGIDO: Usar endpoint correcto
  const fetchPagos = async () => {
    try {
      setLoading(true);
      // Usar el endpoint que realmente existe
     // const response = await axios.get(`${config.API_BASE_URL}/api/liquidacion/pagos-pendientes`, {
        const response = await axios.get(`${config.API_BASE_URL}/api/pagos`, {
        headers: { Authorization: `Bearer ${user.token}` }
      });
      
      console.log('Datos recibidos:', response.data); // Para debug
      
      // ✅ CORREGIDO: Los datos vienen directamente, no anidados
      setPagos(response.data.pagos || []);
      setError(null);
    } catch (error) {
      console.error('Error al obtener pagos:', error);
      setError('Error al cargar los pagos. Por favor, inténtelo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  const fetchEstadisticas = async () => {
    try {
      const response = await axios.get(`${config.API_BASE_URL}/api/pagos/estadisticas`, {
        headers: { Authorization: `Bearer ${user.token}` }
      });
      setEstadisticas(response.data);
    } catch (error) {
      console.error('Error al obtener estadísticas:', error);
    }
  };



  const fetchTrabajadores = async () => {
    try {
    const response = await axios.get(`${config.API_BASE_URL}/api/pagos/trabajadores-filtro`, {
        headers: { Authorization: `Bearer ${user.token}` }
      });
      setTrabajadores(response.data || []);
    } catch (error) {
      console.error('Error al obtener trabajadores:', error);
    }
  };

  const refreshData = async () => {
    setRefreshing(true);
    await fetchData();
    setRefreshing(false);
  };

  const applyFilters = () => {
    let filtered = [...pagos];

    // Filtro por texto
    if (filtros.searchTerm) {
      const searchLower = filtros.searchTerm.toLowerCase();
      filtered = filtered.filter(pago =>
        `${pago.nombre_trabajador} ${pago.apellido_trabajador}`.toLowerCase().includes(searchLower) ||
        pago.numero_operacion?.toLowerCase().includes(searchLower) ||
        pago.id_pago.toString().includes(searchLower) ||
        pago.observaciones?.toLowerCase().includes(searchLower)
      );
    }

    // Filtro por estado
    if (filtros.estado) {
      filtered = filtered.filter(pago => pago.estado === filtros.estado);
    }

    // Filtro por método de pago
    if (filtros.metodo_pago) {
      filtered = filtered.filter(pago => pago.metodo_pago === filtros.metodo_pago);
    }

    // Filtro por trabajador
    if (filtros.trabajador_id) {
      filtered = filtered.filter(pago => pago.id_trabajador.toString() === filtros.trabajador_id);
    }

    // ✅ CORREGIDO: Filtro por fechas usando strings
    if (filtros.fecha_desde) {
      filtered = filtered.filter(pago => 
        new Date(pago.fecha_generacion) >= new Date(filtros.fecha_desde)
      );
    }

    if (filtros.fecha_hasta) {
      filtered = filtered.filter(pago => 
        new Date(pago.fecha_generacion) <= new Date(filtros.fecha_hasta)
      );
    }

    // Ordenamiento
    filtered.sort((a, b) => {
      const isAsc = order === 'asc';
      let aValue = a[orderBy];
      let bValue = b[orderBy];

      // Manejo especial para fechas
      if (orderBy.includes('fecha')) {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      }

      // Manejo especial para nombres
      if (orderBy === 'nombre_trabajador') {
        aValue = `${a.nombre_trabajador} ${a.apellido_trabajador}`;
        bValue = `${b.nombre_trabajador} ${b.apellido_trabajador}`;
      }

      if (aValue < bValue) return isAsc ? -1 : 1;
      if (aValue > bValue) return isAsc ? 1 : -1;
      return 0;
    });

    setFilteredPagos(filtered);
    setPage(0);
  };

  const handleFilterChange = (field, value) => {
    setFiltros(prev => ({ ...prev, [field]: value }));
  };

  const clearFilters = () => {
    setFiltros({
      searchTerm: '',
      estado: '',
      metodo_pago: '',
      trabajador_id: '',
      fecha_desde: '',
      fecha_hasta: ''
    });
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const createSortHandler = (property) => () => {
    handleRequestSort(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // ✅ CORREGIDO: Usar endpoint correcto para detalle
  const openDetailDialog = async (pago) => {
    try {
    const response = await axios.get(`${config.API_BASE_URL}/api/pagos/${pago.id_pago}/detalle`, {
        headers: { Authorization: `Bearer ${user.token}` }
      });
      setSelectedPago(response.data);
      setDetailDialogOpen(true);
    } catch (error) {
      console.error('Error al obtener detalle del pago:', error);
      // ✅ CORREGIDO: Si no existe endpoint de detalle, mostrar datos básicos
      setSelectedPago({ pago: pago, servicios: [], egresos: [] });
      setDetailDialogOpen(true);
    }
  };

  const openEditDialog = (pago) => {
    setSelectedPago(pago);
    setEditDialogOpen(true);
  };

  const getEstadoColor = (estado) => {
    switch (estado) {
      case 'PENDIENTE': return 'warning';
      case 'EN_PROCESO': return 'info';
      case 'PAGADO': return 'success';
      case 'CANCELADO': return 'error';
      default: return 'default';
    }
  };

  const getEstadoIcon = (estado) => {
    switch (estado) {
      case 'PENDIENTE': return <ScheduleIcon />;
      case 'EN_PROCESO': return <InfoIcon />;
      case 'PAGADO': return <CheckCircleIcon />;
      case 'CANCELADO': return <ErrorIcon />;
      default: return <InfoIcon />;
    }
  };

  const getInitials = (nombre, apellido) => {
    return `${nombre?.charAt(0) || ''}${apellido?.charAt(0) || ''}`.toUpperCase();
  };

  const formatCurrency = (amount) => {
    const formatted = parseFloat(amount || 0).toLocaleString('es-PE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return `${simboloMoneda} ${formatted}`;
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('es-PE', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const formatDateTime = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('es-PE', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const calculateDaysFromGeneration = (fechaGeneracion) => {
    if (!fechaGeneracion) return 0;
    const now = new Date();
    const generated = new Date(fechaGeneracion);
    const diffTime = Math.abs(now - generated);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  const exportToExcel = async () => {
    try {
      setExporting(true);
      
      const dataToExport = filteredPagos.map(pago => ({
        'ID Pago': pago.id_pago,
        'Trabajador': `${pago.nombre_trabajador} ${pago.apellido_trabajador}`,
        'Fecha Generación': formatDateTime(pago.fecha_generacion),
        'Fecha Pago': formatDateTime(pago.fecha_pago),
        'Monto Bruto': pago.monto_bruto,
        'Descuentos': pago.monto_descuentos,
        'Monto Neto': pago.monto_neto,
        'Cantidad Servicios': pago.cantidad_servicios,
        'Estado': pago.estado,
        'Método Pago': pago.metodo_pago || '-',
        'Nro. Operación': pago.numero_operacion || '-',
        'Días Transcurridos': calculateDaysFromGeneration(pago.fecha_generacion),
        'Observaciones': pago.observaciones || '-'
      }));

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(dataToExport);

      const colWidths = [
        { wch: 10 }, { wch: 25 }, { wch: 18 }, { wch: 18 },
        { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 15 },
        { wch: 12 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 30 }
      ];
      ws['!cols'] = colWidths;

      XLSX.utils.book_append_sheet(wb, ws, 'Historial de Pagos');
      
      const fileName = `historial_pagos_${formatearFechaLocal(new Date())}.xlsx`;
      XLSX.writeFile(wb, fileName);
      
    } catch (error) {
      console.error('Error al exportar:', error);
      setError('Error al exportar los datos');
    } finally {
      setExporting(false);
    }
  };

  // Componente de tarjeta móvil
  const MobilePagoCard = ({ pago }) => (
    <Card 
      sx={{ 
        mb: 2,
        borderRadius: 3,
        border: '1px solid rgba(26, 35, 126, 0.1)',
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 8px 25px rgba(26, 35, 126, 0.15)'
        }
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Avatar
            sx={{
              width: 50,
              height: 50,
              background: 'linear-gradient(135deg, #4FC3F7 0%, #29B6F6 100%)',
              color: 'white',
              fontWeight: 'bold',
              mr: 2
            }}
          >
            {getInitials(pago.nombre_trabajador, pago.apellido_trabajador)}
          </Avatar>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1A237E' }}>
              {pago.nombre_trabajador} {pago.apellido_trabajador}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Pago #{pago.id_pago}
            </Typography>
          </Box>
          <Chip 
            label={pago.estado}
            color={getEstadoColor(pago.estado)}
            size="small"
            icon={getEstadoIcon(pago.estado)}
          />
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">Monto Neto</Typography>
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#4CAF50' }}>
              {formatCurrency(pago.monto_neto)}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">Servicios</Typography>
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
              {pago.cantidad_servicios}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">Generado</Typography>
            <Typography variant="body2">
              {formatDate(pago.fecha_generacion)}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">Días transcurridos</Typography>
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              {calculateDaysFromGeneration(pago.fecha_generacion)} días
            </Typography>
          </Grid>
        </Grid>

        {pago.numero_operacion && (
          <Box sx={{ mt: 2, p: 1, bgcolor: 'rgba(76, 175, 80, 0.1)', borderRadius: 1 }}>
            <Typography variant="caption" color="text.secondary">
              Operación: {pago.numero_operacion}
            </Typography>
          </Box>
        )}

        <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
          <Button
            size="small"
            variant="outlined"
            startIcon={<VisibilityIcon />}
            onClick={() => openDetailDialog(pago)}
          >
            Ver Detalle
          </Button>
          {pago.estado !== 'PAGADO' && pago.estado !== 'CANCELADO' && (
            <Button
              size="small"
              variant="outlined"
              startIcon={<EditIcon />}
              onClick={() => openEditDialog(pago)}
            >
              Editar
            </Button>
          )}
        </Box>
      </CardContent>
    </Card>
  );

  // Componente de estadísticas — estilo unificado con Liquidación
  const StatCard = ({ title, value, icon, color, subtitle }) => (
    <Card sx={{
      borderRadius: 3,
      background: `linear-gradient(135deg, ${color}08, ${color}04)`,
      border: `1px solid ${color}25`,
      transition: 'all 0.2s',
      '&:hover': { transform: 'translateY(-2px)', boxShadow: `0 6px 20px ${color}15` },
    }}>
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box sx={{
            width: 44, height: 44, borderRadius: 2,
            background: `linear-gradient(135deg, ${color}, ${color}CC)`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', flexShrink: 0,
          }}>
            {React.cloneElement(icon, { sx: { fontSize: 22 } })}
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="h5" sx={{ fontWeight: 800, color, lineHeight: 1.1 }}>
              {value}
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 600, color: '#1A237E' }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="caption" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );

  if (loading) {
    return (
      <Box sx={{ width: '100%', p: { xs: 2, sm: 3, md: 4 } }}>
        <Skeleton variant="text" width="60%" height={60} sx={{ mb: 3 }} />
        <Grid container spacing={1.5} sx={{ mb: 3 }}>
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <Grid item xs={6} sm={3} key={i}>
              <Skeleton variant="rectangular" height={76} sx={{ borderRadius: 2 }} />
            </Grid>
          ))}
        </Grid>
        {Array.from({ length: 5 }).map((_, index) => (
          <Skeleton key={index} variant="rectangular" height={60} sx={{ mb: 1, borderRadius: 1 }} />
        ))}
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', p: { xs: 2, sm: 3, md: 4 } }}>
      {/* Header */}
      <Box sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between', 
        alignItems: { xs: 'stretch', sm: 'center' },
        gap: 2,
        mb: 4
      }}>
        <Box>
          <Typography 
            variant={isMobile ? "h5" : "h4"} 
            component="h1"
            sx={{ fontWeight: 'bold', color: '#1A237E', mb: 0.5 }}
          >
            Historial de Pagos
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Gestión completa de pagos realizados a trabajadores
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Tooltip title="Actualizar datos">
            <IconButton 
              onClick={refreshData}
              disabled={refreshing}
              sx={{ 
                bgcolor: 'rgba(26, 35, 126, 0.1)',
                '&:hover': { bgcolor: 'rgba(26, 35, 126, 0.2)' }
              }}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
          
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={exportToExcel}
            disabled={exporting || filteredPagos.length === 0}
            sx={{
              borderColor: '#1A237E',
              color: '#1A237E',
              '&:hover': { borderColor: '#0D47A1', bgcolor: 'rgba(26, 35, 126, 0.04)' }
            }}
          >
            {exporting ? 'Exportando...' : 'Exportar Excel'}
          </Button>
        </Box>
      </Box>

      {/* Alerts */}
      {error && (
        <Alert 
          severity="error" 
          sx={{ mb: 3, borderRadius: 2 }}
          onClose={() => setError(null)}
        >
          {error}
        </Alert>
      )}

      {/* Estadísticas */}
      <Grid container spacing={1.5} sx={{ mb: 3 }}>
        <Grid item xs={6} sm={3}>
          <StatCard
            title="Total Pagos"
            value={estadisticas.total_pagos || 0}
            icon={<ReceiptIcon />}
            color="#1A237E"
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <StatCard
            title="Pendientes"
            value={estadisticas.pagos_pendientes || 0}
            icon={<ScheduleIcon />}
            color="#FF9800"
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <StatCard
            title="En Proceso"
            value={estadisticas.pagos_proceso || 0}
            icon={<InfoIcon />}
            color="#2196F3"
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <StatCard
            title="Completados"
            value={estadisticas.pagos_completados || 0}
            icon={<CheckCircleIcon />}
            color="#4CAF50"
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <StatCard
            title="Monto Pagado"
            value={formatCurrency(estadisticas.monto_total || 0)}
            icon={<MoneyIcon />}
            color="#2E7D32"
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <StatCard
            title="Monto Pendiente"
            value={formatCurrency(estadisticas.monto_pendiente || 0)}
            icon={<WarningIcon />}
            color="#E65100"
          />
        </Grid>
      </Grid>

      {/* Filtros */}
      <Paper sx={{ p: 3, mb: 3, borderRadius: 3 }}>
        <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
          <FilterIcon /> Filtros de Búsqueda
        </Typography>
        
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Buscar"
              placeholder="Nombre, operación, ID..."
              value={filtros.searchTerm}
              onChange={(e) => handleFilterChange('searchTerm', e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          
          <Grid item xs={12} md={2}>
            <FormControl fullWidth>
              <InputLabel>Estado</InputLabel>
              <Select
                value={filtros.estado}
                label="Estado"
                onChange={(e) => handleFilterChange('estado', e.target.value)}
              >
                <MenuItem value="">Todos</MenuItem>
                <MenuItem value="PENDIENTE">Pendiente</MenuItem>
                <MenuItem value="EN_PROCESO">En Proceso</MenuItem>
                <MenuItem value="PAGADO">Pagado</MenuItem>
                <MenuItem value="CANCELADO">Cancelado</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} md={2}>
            <FormControl fullWidth>
              <InputLabel>Método</InputLabel>
              <Select
                value={filtros.metodo_pago}
                label="Método"
                onChange={(e) => handleFilterChange('metodo_pago', e.target.value)}
              >
                <MenuItem value="">Todos</MenuItem>
                <MenuItem value="TRANSFERENCIA">Transferencia</MenuItem>
                <MenuItem value="EFECTIVO">Efectivo</MenuItem>
                <MenuItem value="CHEQUE">Cheque</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel>Trabajador</InputLabel>
              <Select
                value={filtros.trabajador_id}
                label="Trabajador"
                onChange={(e) => handleFilterChange('trabajador_id', e.target.value)}
              >
                <MenuItem value="">Todos</MenuItem>
                {trabajadores.map((trabajador) => (
                  <MenuItem key={trabajador.id_trabajador} value={trabajador.id_trabajador.toString()}>
                    {trabajador.nombre_trabajador} {trabajador.apellido_trabajador}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={3}>
            {/* ✅ CORREGIDO: Usar TextField con type="date" en lugar de DatePicker */}
            <TextField
              fullWidth
              type="date"
              label="Fecha desde"
              value={filtros.fecha_desde}
              onChange={(e) => handleFilterChange('fecha_desde', e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          
          <Grid item xs={12} md={3}>
            {/* ✅ CORREGIDO: Usar TextField con type="date" en lugar de DatePicker */}
            <TextField
              fullWidth
              type="date"
              label="Fecha hasta"
              value={filtros.fecha_hasta}
              onChange={(e) => handleFilterChange('fecha_hasta', e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          
          <Grid item xs={12} md={6} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Button
              variant="outlined"
              startIcon={<ClearIcon />}
              onClick={clearFilters}
              disabled={Object.values(filtros).every(v => !v)}
            >
              Limpiar Filtros
            </Button>
            
            <Typography variant="body2" color="text.secondary" sx={{ ml: 2 }}>
              Mostrando {filteredPagos.length} de {pagos.length} pagos
            </Typography>
          </Grid>
        </Grid>
      </Paper>

      {/* Tabla / Vista móvil */}
      {isMobile ? (
        // Vista móvil con tarjetas
        <Box>
          {filteredPagos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((pago) => (
            <MobilePagoCard key={pago.id_pago} pago={pago} />
          ))}
        </Box>
      ) : (
        // Vista desktop con tabla
        <TableContainer component={Paper} sx={{ borderRadius: 3, mb: 3 }}>
          <Table>
            <TableHead sx={{ bgcolor: 'rgba(26, 35, 126, 0.04)' }}>
              <TableRow>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === 'id_pago'}
                    direction={orderBy === 'id_pago' ? order : 'asc'}
                    onClick={createSortHandler('id_pago')}
                    sx={{ fontWeight: 'bold' }}
                  >
                    ID
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === 'nombre_trabajador'}
                    direction={orderBy === 'nombre_trabajador' ? order : 'asc'}
                    onClick={createSortHandler('nombre_trabajador')}
                    sx={{ fontWeight: 'bold' }}
                  >
                    Trabajador
                  </TableSortLabel>
                </TableCell>
                <TableCell align="center">
                  <TableSortLabel
                    active={orderBy === 'fecha_generacion'}
                    direction={orderBy === 'fecha_generacion' ? order : 'asc'}
                    onClick={createSortHandler('fecha_generacion')}
                    sx={{ fontWeight: 'bold' }}
                  >
                    F. Generación
                  </TableSortLabel>
                </TableCell>
                <TableCell align="right">
                  <TableSortLabel
                    active={orderBy === 'monto_neto'}
                    direction={orderBy === 'monto_neto' ? order : 'asc'}
                    onClick={createSortHandler('monto_neto')}
                    sx={{ fontWeight: 'bold' }}
                  >
                    Monto Neto
                  </TableSortLabel>
                </TableCell>
                <TableCell align="center">Servicios</TableCell>
                <TableCell align="center">Estado</TableCell>
                <TableCell align="center">Días</TableCell>
                <TableCell align="center">Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredPagos
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((pago) => (
                  <TableRow 
                    key={pago.id_pago}
                    sx={{ 
                      '&:hover': { bgcolor: 'rgba(26, 35, 126, 0.04)' },
                      '&:nth-of-type(odd)': { bgcolor: 'rgba(0, 0, 0, 0.02)' }
                    }}
                  >
                    <TableCell>
                      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                        #{pago.id_pago}
                      </Typography>
                    </TableCell>
                    
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Avatar
                          sx={{
                            width: 40,
                            height: 40,
                            bgcolor: '#1A237E',
                            fontSize: '0.875rem'
                          }}
                        >
                          {getInitials(pago.nombre_trabajador, pago.apellido_trabajador)}
                        </Avatar>
                        <Box>
                          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                            {pago.nombre_trabajador} {pago.apellido_trabajador}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {pago.numero_operacion || 'Sin operación'}
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>
                    
                    <TableCell align="center">
                      <Typography variant="body2">
                        {formatDate(pago.fecha_generacion)}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {formatDateTime(pago.fecha_generacion).split(' ')[1]}
                      </Typography>
                    </TableCell>
                    
                    <TableCell align="right">
                      <Box>
                        <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#4CAF50' }}>
                          {formatCurrency(pago.monto_neto)}
                        </Typography>
                        {pago.monto_descuentos > 0 && (
                          <Typography variant="caption" color="text.secondary">
                            Bruto: {formatCurrency(pago.monto_bruto)}
                          </Typography>
                        )}
                      </Box>
                    </TableCell>
                    
                    <TableCell align="center">
                      <Chip 
                        label={pago.cantidad_servicios}
                        size="small"
                        color="primary"
                        variant="outlined"
                      />
                    </TableCell>
                    
                    <TableCell align="center">
                      <Chip 
                        label={pago.estado}
                        color={getEstadoColor(pago.estado)}
                        size="small"
                        icon={getEstadoIcon(pago.estado)}
                      />
                    </TableCell>
                    
                    <TableCell align="center">
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          fontWeight: 'bold',
                          color: calculateDaysFromGeneration(pago.fecha_generacion) > 7 ? '#FF5722' : '#666'
                        }}
                      >
                        {calculateDaysFromGeneration(pago.fecha_generacion)}
                      </Typography>
                    </TableCell>
                    
                    <TableCell align="center">
                      <Box sx={{ display: 'flex', gap: 0.5 }}>
                        <Tooltip title="Ver detalle completo">
                          <IconButton
                            size="small"
                            onClick={() => openDetailDialog(pago)}
                            sx={{ color: '#1976D2' }}
                          >
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        
                        {pago.estado !== 'PAGADO' && pago.estado !== 'CANCELADO' && (
                          <Tooltip title="Editar pago">
                            <IconButton
                              size="small"
                              onClick={() => openEditDialog(pago)}
                              sx={{ color: '#FF9800' }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* Paginación */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
        <TablePagination
          component="div"
          count={filteredPagos.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[]}
          labelDisplayedRows={({ from, to, count }) => 
            `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
          }
          labelRowsPerPage=""
          sx={{
            '.MuiTablePagination-toolbar': {
              fontSize: '0.875rem'
            }
          }}
        />
      </Box>

      {/* Diálogo de Detalle */}
      <Dialog 
        open={detailDialogOpen} 
        onClose={() => setDetailDialogOpen(false)}
        maxWidth="md" 
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6">
              Detalle del Pago #{selectedPago?.pago?.id_pago || selectedPago?.id_pago}
            </Typography>
            <IconButton onClick={() => setDetailDialogOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        
        <DialogContent>
          {selectedPago && (
            <Box>
              {/* Información del trabajador */}
              <Card sx={{ mb: 3, bgcolor: 'rgba(26, 35, 126, 0.04)' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                    <Avatar sx={{ width: 60, height: 60, bgcolor: '#1A237E' }}>
                      {getInitials(
                        selectedPago.pago?.nombre_trabajador || selectedPago.nombre_trabajador, 
                        selectedPago.pago?.apellido_trabajador || selectedPago.apellido_trabajador
                      )}
                    </Avatar>
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        {selectedPago.pago?.nombre_trabajador || selectedPago.nombre_trabajador} {' '}
                        {selectedPago.pago?.apellido_trabajador || selectedPago.apellido_trabajador}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Pago generado el {formatDateTime(selectedPago.pago?.fecha_generacion || selectedPago.fecha_generacion)}
                      </Typography>
                    </Box>
                    <Chip 
                      label={selectedPago.pago?.estado || selectedPago.estado}
                      color={getEstadoColor(selectedPago.pago?.estado || selectedPago.estado)}
                      icon={getEstadoIcon(selectedPago.pago?.estado || selectedPago.estado)}
                    />
                  </Box>
                </CardContent>
              </Card>

              {/* Resumen financiero */}
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={6} md={3}>
                  <Card>
                    <CardContent sx={{ textAlign: 'center' }}>
                      <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold' }}>
                        {formatCurrency(selectedPago.pago?.monto_bruto || selectedPago.monto_bruto)}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Monto Bruto
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Card>
                    <CardContent sx={{ textAlign: 'center' }}>
                      <Typography variant="h6" color="error" sx={{ fontWeight: 'bold' }}>
                        {formatCurrency(selectedPago.pago?.monto_descuentos || selectedPago.monto_descuentos)}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Descuentos
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Card>
                    <CardContent sx={{ textAlign: 'center' }}>
                      <Typography variant="h6" color="success.main" sx={{ fontWeight: 'bold' }}>
                        {formatCurrency(selectedPago.pago?.monto_neto || selectedPago.monto_neto)}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Monto Neto
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Card>
                    <CardContent sx={{ textAlign: 'center' }}>
                      <Typography variant="h6" color="info.main" sx={{ fontWeight: 'bold' }}>
                        {selectedPago.pago?.cantidad_servicios || selectedPago.cantidad_servicios}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Servicios
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

              {/* Información del pago */}
              {((selectedPago.pago?.metodo_pago || selectedPago.metodo_pago) || 
                (selectedPago.pago?.numero_operacion || selectedPago.numero_operacion)) && (
                <Card sx={{ mb: 3 }}>
                  <CardContent>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                      Información del Pago
                    </Typography>
                    <Grid container spacing={2}>
                      {(selectedPago.pago?.metodo_pago || selectedPago.metodo_pago) && (
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" color="text.secondary">Método de Pago</Typography>
                          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                            {selectedPago.pago?.metodo_pago || selectedPago.metodo_pago}
                          </Typography>
                        </Grid>
                      )}
                      {(selectedPago.pago?.numero_operacion || selectedPago.numero_operacion) && (
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" color="text.secondary">Número de Operación</Typography>
                          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                            {selectedPago.pago?.numero_operacion || selectedPago.numero_operacion}
                          </Typography>
                        </Grid>
                      )}
                      {(selectedPago.pago?.fecha_pago || selectedPago.fecha_pago) && (
                        <Grid item xs={12}>
                          <Typography variant="body2" color="text.secondary">Fecha de Pago</Typography>
                          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                            {formatDateTime(selectedPago.pago?.fecha_pago || selectedPago.fecha_pago)}
                          </Typography>
                        </Grid>
                      )}
                    </Grid>
                  </CardContent>
                </Card>
              )}

              {/* Servicios incluidos */}
              {selectedPago.servicios && selectedPago.servicios.length > 0 && (
                <Card sx={{ mb: 3 }}>
                  <CardContent>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                      Servicios Incluidos ({selectedPago.servicios.length})
                    </Typography>
                    <List>
                      {selectedPago.servicios.map((servicio, index) => (
                        <ListItem key={index} sx={{ px: 0 }}>
                          <ListItemAvatar>
                            <Avatar sx={{ bgcolor: '#4CAF50', width: 32, height: 32 }}>
                              <AssessmentIcon fontSize="small" />
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <Typography variant="body2">
                                Orden #{servicio.id_orden_servicio} - {servicio.nombre_cliente}
                              </Typography>
                            }
                            secondary={
                              <Typography variant="caption" color="text.secondary">
                                Comisión: {formatCurrency(servicio.comision_pagada)} 
                                ({servicio.porcentaje_comision}% de {formatCurrency(servicio.precio_servicio)})
                              </Typography>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  </CardContent>
                </Card>
              )}

              {/* Egresos descontados */}
              {selectedPago.egresos && selectedPago.egresos.length > 0 && (
                <Card sx={{ mb: 3 }}>
                  <CardContent>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                      Descuentos Aplicados ({selectedPago.egresos.length})
                    </Typography>
                    <List>
                      {selectedPago.egresos.map((egreso, index) => (
                        <ListItem key={index} sx={{ px: 0 }}>
                          <ListItemAvatar>
                            <Avatar sx={{ bgcolor: '#FF5722', width: 32, height: 32 }}>
                              <WarningIcon fontSize="small" />
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <Typography variant="body2">
                                {egreso.tipo_egreso}: {egreso.concepto}
                              </Typography>
                            }
                            secondary={
                              <Typography variant="caption" color="text.secondary">
                                Monto: {formatCurrency(egreso.monto_descontado)} - 
                                Fecha: {formatDate(egreso.fecha_egreso)}
                              </Typography>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  </CardContent>
                </Card>
              )}

              {/* Observaciones */}
              {(selectedPago.pago?.observaciones || selectedPago.observaciones) && (
                <Card>
                  <CardContent>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                      Observaciones
                    </Typography>
                    <Typography variant="body2">
                      {selectedPago.pago?.observaciones || selectedPago.observaciones}
                    </Typography>
                  </CardContent>
                </Card>
              )}
            </Box>
          )}
        </DialogContent>
        
        <DialogActions>
          <Button onClick={() => setDetailDialogOpen(false)}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Diálogo de Edición (placeholder) */}
      <Dialog 
        open={editDialogOpen} 
        onClose={() => setEditDialogOpen(false)}
        maxWidth="sm" 
        fullWidth
      >
        <DialogTitle>
          Editar Pago #{selectedPago?.id_pago}
        </DialogTitle>
        <DialogContent>
          <Alert severity="info" sx={{ mt: 2 }}>
            La funcionalidad de edición está en desarrollo. 
            Por ahora, consulta con el administrador del sistema.
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditDialogOpen(false)}>
            Cerrar   
          </Button>
        </DialogActions>
      </Dialog>

      {/* FAB para vista móvil */}
      {isMobile && (
        <Fab
          color="primary"
          sx={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            background: 'linear-gradient(135deg, #1A237E 0%, #3949AB 100%)'
          }}
          onClick={refreshData}
        >
          <RefreshIcon />
        </Fab>
      )}
    </Box>
  );
}

export default PagosAdmin;